import { AxiosPostJson, AxiosGetJson } from "src/Service/Config/AxiosMethod";
import { AuthToken } from "src/Service/Config/AuthToken";
import { getHistory } from "src/App";
export default class SystemFn {
 
    static GetMenuWithPermission(data) { //Beam Add
        const response = AxiosPostJson('/Auth/GetPermissionPage', data);
        return response.then(f => f.data);
    }

    static GetMenuWithPermission_CreateIdea(data) { //Beam Add
        const response = AxiosPostJson('/Auth/GetPermissionPage_CreateIdea', data);
        return response.then(f => f.data);
    }
    
}